const config = {
  SFAPIURL: 'VITE_GRAPHQL_API_URL_PLACEHOLDER',
  portalAuthURL: 'VITE_PORTAL_AUTH_URL_PLACEHOLDER',
  portalAuthDomain: 'VITE_PORTAL_AUTH_DOMAIN_PLACEHOLDER',
  hashRouting: false,
};

export default config;
